var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.7125 0 0 6.88228 0 15.3794C0 22.1848 4.29375 27.9328 10.2562 29.9706C11.0062 30.1052 11.2875 29.6438 11.2875 29.2401C11.2875 28.8748 11.2687 27.6637 11.2687 26.3757C7.5 27.087 6.525 25.4337 6.225 24.5686C6.05625 24.1264 5.325 22.7615 4.6875 22.3963C4.1625 22.1079 3.4125 21.3966 4.66875 21.3774C5.85 21.3582 6.69375 22.4924 6.975 22.9538C8.325 25.2799 10.4812 24.6263 11.3437 24.2226C11.475 23.2229 11.8687 22.5501 12.3 22.1656C8.9625 21.7811 5.475 20.4546 5.475 14.572C5.475 12.8995 6.05625 11.5153 7.0125 10.4388C6.8625 10.0543 6.3375 8.4779 7.1625 6.36323C7.1625 6.36323 8.41875 5.95952 11.2875 7.93962C12.4875 7.59358 13.7625 7.42056 15.0375 7.42056C16.3125 7.42056 17.5875 7.59358 18.7875 7.93962C21.6563 5.9403 22.9125 6.36323 22.9125 6.36323C23.7375 8.4779 23.2125 10.0543 23.0625 10.4388C24.0187 11.5153 24.6 12.8803 24.6 14.572C24.6 20.4738 21.0938 21.7811 17.7562 22.1656C18.3 22.6462 18.7687 23.5689 18.7687 25.0108C18.7687 27.0678 18.75 28.721 18.75 29.2401C18.75 29.6438 19.0312 30.1244 19.7812 29.9706C22.7595 28.9407 25.3475 26.9787 27.1808 24.361C29.014 21.7434 30 18.602 30 15.3794C30 6.88228 23.2875 0 15 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubw);
export default __webpack_public_path__ + "static/media/githubw.cc0ad868c69b696e5d368ea460b3527e.svg";
export { ForwardRef as ReactComponent };